import React, { Fragment, useEffect, useState } from "react";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import Grid from "@material-ui/core/Grid";
import { toggleWishListAction } from "../../../../redux/actions/wishListActions.js";
import { Link } from "gatsby";

import { PROJECT_LINK } from "../../../../project-config.js";
import Facets from "../../../OFB-Category/components/AC-Facets/BDFacets.jsx";

const CategoryItems = ({ data, pageContext, supplier, allMenus, dynamic }) => {
  console.log("dynamic", dynamic);
  const dispatch = useDispatch();
  const [categoryItems, setCategoryItems] = useState(
    dynamic === false &&
      (pageContext.currentPage === 1
        ? data.itemsFirstPage
        : data.otherPages[`_${pageContext.currentPage}`])
  );

  const loading = useSelector(
    state => state.categoryReducer.loading,
    shallowEqual
  );
  const breadState = useSelector(
    state => state.facetReducer.bread,
    shallowEqual
  );
  const urlFilterParamsState = useSelector(
    state => state.facetReducer.urlFilterParams,
    shallowEqual
  );

  const clientSideCategoryItemState = useSelector(
    state => state.categoryReducer.categoryItems,
    shallowEqual
  );

  const backButtonState = useSelector(
    state => state.categoryReducer.backButton,
    shallowEqual
  );

  const scroolPageState = useSelector(
    state => state.categoryReducer.scroolPage,
    shallowEqual
  );

  const currentPageState = useSelector(
    state => state.categoryReducer.currentPage,
    shallowEqual
  );

  const itemsFetchedState = useSelector(
    state => state.categoryReducer.itemsFetched,
    shallowEqual
  );

  const showDynamicState = useSelector(
    state => state.categoryReducer.showDynamic,
    shallowEqual
  );

  const navCatsState = useSelector(
    state => state.menuReducer.navCats,
    shallowEqual
  );

  useEffect(() => {
    if (dynamic || showDynamicState || breadState.length > 0) {
      setCategoryItems(clientSideCategoryItemState);
    } else {
      setCategoryItems(
        pageContext.currentPage === 1
          ? data.itemsFirstPage
          : data.otherPages[`_${pageContext.currentPage}`]
      );
    }
  }, [
    breadState,
    clientSideCategoryItemState,
    urlFilterParamsState,
    scroolPageState,
    showDynamicState
  ]);

  const wishListState = useSelector(
    state => state.wishListReducer.wishlist,
    shallowEqual
  );
  const isMobileState = useSelector(
    state => state.mainReducer.isMobile,
    shallowEqual
  );

  const itemsAreBeingFetchedState = useSelector(
    state => state.facetReducer.itemsAreBeingFetched,
    shallowEqual
  );

  const toggleWish = (
    e,
    id,
    code,
    title,
    desc,
    currency_sign,
    image,
    price,
    url
  ) => {
    e.preventDefault();

    dispatch(
      toggleWishListAction(
        id,
        code,
        title,
        desc,
        currency_sign,
        image,
        price,
        url,
        wishListState
      )
    );
  };

  if (itemsAreBeingFetchedState) {
    return renderPlaceholderCategoryItems();
  } else {
    return renderCategoryItems(
      categoryItems,
      toggleWish,
      wishListState,
      supplier,
      allMenus,
      dynamic,
      navCatsState
    );
  }
};

const renderPriceSection = item => {
  console.info("item", item);
  let priceState = { price: null, quantity: null };
  if (item.prices && item.prices.length > 0) {
    if (
      item.prices[0].packagePrices &&
      item.prices[0].packagePrices.length > 0
    ) {
      //find the package price with itemcode that includes "-1"
      let packagePriceWithDash1 = item.prices.find(a =>
        a.itemcode.includes("-1")
      );

      if (!packagePriceWithDash1) {
        packagePriceWithDash1 = item.prices[0];
      }

      console.log("packagePriceWithDash1", item.prices, packagePriceWithDash1);
      const firstPackage = packagePriceWithDash1.packagePrices[0];
      if (firstPackage)
        priceState = {
          price: firstPackage.price,
          quantity: firstPackage.quantity
        };
    } else {
      const firstPrice = item.prices[0];
      if (firstPrice)
        priceState = {
          price: firstPrice.price_1
        };
    }
  }

  const renderQuantityText = quantity => {
    return quantity > 1 ? "Products" : "Product";
  };
  return (
    <div className="price-highlight-sm">
      {item.currency_sign}
      {`${priceState.price}`}
      <span className="price-lowlight-sm">
        {priceState.quantity
          ? `/ ${priceState.quantity} ${renderQuantityText(
              priceState.quantity
            )}`
          : "Each"}
      </span>
    </div>
  );
};

const renderCategoryItems = (
  categoryItems,
  toggleWish,
  wishListState,
  supplier,
  allMenus,
  dynamic,
  navCatsState
) => {
  let y = 0;
  if (categoryItems && categoryItems.length > 0) {
    return (
      <div className="h-container">
        {/**This menu is currently hardcoded, we need it to grab the correct categories instead TODO .*/}
        {/* Original page here for example: 
     https://staples.nebs.ca/shop/StaplesEnglish/computer-cheques/laser-cheques/?dllt=14f8587b*/}

        <div container className="h-container-products" style={{}}>
          {categoryItems &&
            categoryItems.map((item, index) => {
              let supplierData =
                Object.keys(item).includes("properties") &&
                Object.keys(item.properties).includes("Created_By_Supplier")
                  ? supplier.filter(
                      sup =>
                        sup.supplier_vendorId ===
                        item.properties.Created_By_Supplier
                    )
                  : [];

              //   Creates line break after 3 products have been created
              // if (y > 2) {
              //   /*index-- in theory should fix the object skipping when creating new line. it doesn't? the logic itself seems sound TODO  */
              //   index--; /* Problem is, it skips objects when creating a line break element. Open a category page  */
              //   y = 0; /* and you'll see for example it says 13 products found, but only 10 would be displayed.  */
              //   return (
              //     /* as line breaks don't let the original show up even with me setting the index back. -Roman   */

              //     <Fragment>
              //       {/*Good page to test this on: http://127.0.0.1:8000/StaplesEnglish/computer-cheques/laser-cheques/   */}
              //       <div
              //         className="flex-break"
              //         style={{ minWidth: "100%" }}
              //       ></div>
              //       {/*index being rendered with the line break for ease of troubleshooting */}
              //     </Fragment>
              //   );
              // }
              y++; /**We only add to y if we're making a new line. As a return should restart the loop from the top*/

              return (
                /** TODO : On click, item page doesn't seem to exist for any items */
                <div className="h-display-grid-item3" key={index}>
                  <Link
                    to={`/${categoryItems[index].url.replace(
                      "StaplesEnglish/",
                      ""
                    )}`}
                  >
                    {/*  {y++}  */}
                    {item.supplier_vendorId}
                    <div className="sm-img-container">
                      <div></div>
                      <img
                        src={
                          PROJECT_LINK +
                          "/" +
                          categoryItems[index].itemLargeImage
                        }
                        aria-hidden="true"
                        alt={item.title}
                      ></img>
                      {/*Do we have an "alt" value in the data for images?. TODO */}
                    </div>
                    {/*Not sure how to make images load properly. TODO */}
                    <div>
                      <div className="v-container">
                        <div className="title-container-category-item-card">
                          <span
                            dangerouslySetInnerHTML={{ __html: item.title }}
                          ></span>
                        </div>
                        {/*Visible item index here, for troubleshooting ease. Also shown on linebreaks*/}
                        {item.code}
                        <div className="cheque-price-container3">
                          AS LOW AS
                          {/* TODO  Prices are null or 0? Or not being grabbed at all?*/}
                          {renderPriceSection(item)}
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              );
            })}
        </div>
      </div>
    );
  } else {
    return (
      <Grid container className="item-card-container">
        <Grid item className="item-card-item" lg={12}>
          <p>Sorry, there seems to be nothing here. Please try again later.</p>
        </Grid>
      </Grid>
    );
  }
};

export const renderPlaceholderCategoryItems = () => {
  return (
    <Grid container className="item-card-container">
      {Array(8)
        .fill(0, 0, 8)
        .map(_ => (
          <Grid item className="item-card-item" xs={12} sm={6} md={4} lg={3}>
            <div
              className="placeholder-item-card-wrapper"
              style={{ boxShadow: "0px 0px 1px 0px #c8c8c8" }}
            >
              <div
                style={{
                  backgroundColor: "#fff",
                  height: "260px"
                }}
              ></div>
              <div>
                <div
                  style={{
                    backgroundColor: "#f5f5f5",
                    height: "40px"
                  }}
                ></div>
              </div>
            </div>
          </Grid>
        ))}
    </Grid>
  );
};

export default CategoryItems;
